import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import {
  Menu, Dropdown, Avatar, Typography, Switch,
} from 'antd';
import {
  LogoutOutlined, UserOutlined,
  BugOutlined,
} from '@ant-design/icons';
import './HeaderDropdownOptions.less';
import firebase from 'firebase';
import { AuthContext } from 'util/Auth';
import * as api from 'util/api.js';

const { Text } = Typography;

const HeaderDropdownOptions = ({
  showFeedbackButtons,
  onReportBugClicked,
  showLegacyPages,
  onToggleLegacy,
}) => {
  const { currentUser } = useContext(AuthContext);
  const { displayName, email } = currentUser;

  const handleLogout = async () => {
    try {
      await firebase.auth().signOut();
    } catch (error) {
      api.reportError(error);
    }
  };

  return (
    <Dropdown
      trigger="click"
      overlay={(
        <Menu>
          <Menu.Item disabled id="name-menu-item">
            <Text strong>{displayName || email}</Text>
          </Menu.Item>
          {showFeedbackButtons && (
            <>
              <Menu.Divider />
              <Menu.Item
                icon={<BugOutlined />}
                onClick={onReportBugClicked}
              >
                Report a bug
              </Menu.Item>
            </>
          )}
          <Menu.Divider />
          <Menu.Item
            id="show-legacy-pages-menu-item"
            onClick={({ domEvent }) => {
              // Row click toggles; Switch handles its own click via onChange
              if (!domEvent.target.closest('.ant-switch')) {
                onToggleLegacy(!showLegacyPages);
              }
            }}
          >
            <div
              style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
                gap: 12,
                minWidth: 180,
              }}
            >
              <span>Show legacy pages</span>
              <Switch
                size="small"
                checked={showLegacyPages}
                onChange={onToggleLegacy}
              />
            </div>
          </Menu.Item>
          <Menu.Divider />
          <Menu.Item icon={<LogoutOutlined />} onClick={handleLogout}>
            Logout
          </Menu.Item>
        </Menu>
      )}
      placement="bottomCenter"
    >
      <div id="current-user-avatar">
        <Avatar
          icon={<UserOutlined />}
          src={currentUser?.photoURL}
        />
      </div>
    </Dropdown>
  );
};

HeaderDropdownOptions.propTypes = {
  showFeedbackButtons: PropTypes.bool,
  onReportBugClicked: PropTypes.func.isRequired,
  showLegacyPages: PropTypes.bool,
  onToggleLegacy: PropTypes.func,
};

HeaderDropdownOptions.defaultProps = {
  showFeedbackButtons: false,
  showLegacyPages: false,
  onToggleLegacy: () => {},
};

export default HeaderDropdownOptions;
